import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import LinkedInSidebar from '../LinkedInSidebar';
import { Heart, Eye } from "lucide-react";
import axios from "axios";

const TermsPage = ({ currentPage, setCurrentPage, setTitleDescription }) => {
  const navigate = useNavigate();

  useEffect(() => {
    setTitleDescription("Fractofolio - Terms of Service", "The future of investment networking! Discover market insights, and make informed investment decisions with our community.")
  }, []);
  
  return (
    <div className="linkedin-layout bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          <div className="hidden lg:block lg:col-span-1">
            <LinkedInSidebar currentPage={currentPage} setCurrentPage={setCurrentPage} />
          </div>
          
          <div className="lg:col-span-3 space-y-4">
            {/* Hero Post */}
            <div className="linkedin-card">
              <div className="linkedin-card-header">
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-blue-800 rounded-full flex items-center justify-center">
                    <span className="text-white font-bold text-lg">FR</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Terms of Service</h3>
                    <p className="text-sm text-gray-600">Last Updated: 15 March 2025</p>
                  </div>
                </div>
              </div>
              
              <div className="linkedin-card-content">
                <div className="text-sm">
                  <p className="mt-3 font-regular">Welcome to <strong>Fractofolio</strong>! These <strong>Terms of Service</strong> (&quot;Terms&quot;) govern your access to and use of our website and services. By using Fractofolio, you agree to comply with these Terms. If you do not agree, please do not use our services.</p>

                  <p className="mt-3 font-bold">1. Use of Our Services</p>
                  <p className="font-regular">Fractofolio provides company evaluations of public companies to assist investors in decision-making. You must be at least <strong>18 years old</strong> to use our services.</p>

                  <p className="font-regular">By using our platform, you agree that you will <strong>not</strong>:</p>
                  <p className="font-regular">- Use our services for unlawful purposes.<br/>
                  - Attempt to disrupt, hack, or manipulate our platform.<br/>
                  - Copy, distribute, or resell any data or content from Fractofolio without permission.</p>

                  <p className="font-regular">We reserve the right to <strong>suspend or terminate</strong> your access if you violate these Terms.</p>

                  <p className="mt-3 font-bold">2. Subscription and Payments</p>
                  <p className="font-regular">Fractofolio operates on a <strong>subscription model</strong>. By subscribing, you agree to pay the applicable fees as outlined on our website.</p>

                  <p className="font-regular">- Your subscription will <strong>automatically renew</strong> unless canceled before the renewal date.<br/>
                  - Payments are <strong>non-refundable</strong>, except where required by law.<br/>
                  - We reserve the right to <strong>change our pricing</strong> with prior notice.</p>

                  <p className="font-regular">Failure to pay may result in suspension or termination of your access to the service.</p>

                  <p className="mt-3 font-bold">3. No Financial Advice</p>
                  <p className="font-regular"><strong>Fractofolio does not provide financial, investment, or legal advice.</strong> All content, data, and company evaluations on our platform are for <strong>informational purposes only</strong>.</p>

                  <p className="font-regular">- We do not guarantee the accuracy, completeness, or reliability of any information provided.<br/>
                  - Any investment decisions you make based on Fractofolio&apos;s content are made at <strong>your own risk</strong>.<br/>
                  - You should <strong>consult a professional financial advisor</strong> before making investment decisions.</p>

                  <p className="font-regular">By using our services, you acknowledge that we are <strong>not responsible</strong> for any financial outcomes resulting from your use of our platform.</p>

                  <p className="mt-3 font-bold">4. Limitation of Liability</p>
                  <p className="font-regular">To the fullest extent permitted by law, Fractofolio and its team <strong>shall not be liable</strong> for:</p>

                  <p className="font-regular">- Any direct, indirect, incidental, or consequential losses from using our services.<br/>
                  - Investment losses, missed opportunities, or financial damages.<br/>
                  - Any third-party content, links, or services accessed through our platform.</p>

                  <p className="font-regular">Our total liability, if any, is <strong>limited to the amount you paid for our service in the past 6 months</strong>.</p>

                  <p className="mt-3 font-bold">5. Changes to Terms</p>
                  <p className="font-regular">We may update these Terms from time to time. When we do, we will update the &quot;Last Updated&quot; date at the top of this page. <strong>Continued use of Fractofolio after changes means you accept the updated Terms.</strong></p>

                  <p className="mt-3 font-bold">6. Governing Law</p>
                  <p className="font-regular">These Terms shall be governed by and interpreted in accordance with the laws of <strong>Costa Rica</strong>, without regard to conflict of law principles.</p>

                  <p className="mt-3 font-bold">7. Contact Information</p>
                  <p className="font-regular">If you have any questions about these Terms, please contact us at:</p>
                  <p className="font-regular">📧 <strong>info@fractofolio.com</strong></p>

                </div>
              </div>
              
              <div className="linkedin-card-actions">
                {/* <button className="linkedin-action-btn">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                  </svg>
                  Like
                </button> */}
                {/* <CommentSection postId="hero" /> */}
                {/* <button className="linkedin-action-btn">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.367 2.684 3 3 0 00-5.367-2.684z" />
                  </svg>
                  Share
                </button> */}
              </div>
              {/* <CommentSectionExpanded postId="hero" /> */}
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default TermsPage;